'use client';

import dynamic from 'next/dynamic';

import Breadcrumbs from '@sympla/sympla-components/Breadcrumbs';

import useClosedSearchEvent from 'hooks/useClosedSearchEvent';
import { ParamsResult } from 'ParamsResult';
import { PAGES_URL } from 'constants/index';
import * as styles from './ClosedSearchSubHeader.css';

const SearchFilter = dynamic(() => import('components/SearchFilter/SearchFilter'), { ssr: false });

const baseBreadcrumb = [
  { label: 'Home', link: PAGES_URL.home },
  { label: 'Encontre eventos', link: PAGES_URL.events },
];

export const buildBreadcrumbList = (params: ParamsResult) => {
  const listArr = Object.values(params.url_params);
  listArr.pop();

  const list = listArr.map((item) => ({
    label: item?.name,
    link: `${PAGES_URL.events}/${item?.slug}`,
  }));

  return [...baseBreadcrumb, ...list];
};

function ClosedSearchSubHeader({ params }: { params: ParamsResult }) {
  const searchEventClosed = useClosedSearchEvent();
  /** only in redirects to search page {sell all, dates} */
  /** gastronomico/em-alta */
  const title = params?.url_params?.component?.name
    /** belo-horizonte-mg/hoje */
    || (params?.search_params?.component_uuid?.toUpperCase())
    /** gastronomico/hoje */
    || params?.url_params?.date?.name
    /** empty */
    || 'Encontre eventos';

  return (
    <div className={styles.ContainerClosedSearchSubHeader}>
      <div className={styles.BreadcrumbsClosedSearchSubHeader}>
        <Breadcrumbs list={buildBreadcrumbList(params)} />
      </div>

      <div className={styles.ContentClosedSearchSubHeader}>
        <h1 className={styles.SearchActionTitle}>{title}</h1>
        <SearchFilter fetchData={(query) => searchEventClosed.fetchData(query)} />
      </div>
    </div>
  );
}

export default ClosedSearchSubHeader;
